module.exports = __webpack_public_path__ + "static/media/found.8743ae4c.gif";